import React from 'react'
import { Link } from 'react-router-dom'
import Logo from '../Assets/Images/logo.png';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faFacebookF, faInstagram, faLinkedinIn, faXTwitter } from '@fortawesome/free-brands-svg-icons';
import ScrollHandler from './ScrollHandler/ScrollHandler';
import { faAngleUp } from '@fortawesome/free-solid-svg-icons';

function Footer() {
    // const [visible, setVisible] = useState(false);

    // useEffect(() => {
    //     // Show button after scrolling 1000px
    //     const toggleVisibility = () => {
    //         setVisible(window.scrollY > 1000);
    //     };

    //     window.addEventListener('scroll', toggleVisibility);
    //     return () => window.removeEventListener('scroll', toggleVisibility);
    // }, []);

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    return (
        <>
            <footer className="footer-area footer-area-2 pd-top-105">
                <div className="container">
                    <div className="footer-widget-area">
                        <div className="row">
                            <div className="col-lg-5 col-md-6">
                                <div className="footer-widget widget">
                                    <div className="about_us_widget">
                                        <Link href="index.html" className="footer-logo">
                                            <img src={Logo} alt="footer logo" />
                                        </Link>
                                        <p>To send your inquiries or to talk to an expert, please send us an email or call us on the given phone number</p>
                                        {/* <ul className="social-icon">
                                            <li>
                                                <Link className="facebook" href="#" target="_blank">
                                                    <FontAwesomeIcon icon={faFacebookF} />
                                                </Link>
                                            </li>
                                            <li>
                                                <Link className="twitter" href="#" target="_blank">
                                                    <FontAwesomeIcon icon={faXTwitter} />
                                                </Link>
                                            </li>
                                            <li>
                                                <Link className="linkedin" href="#" target="_blank">
                                                    <FontAwesomeIcon icon={faLinkedinIn} />
                                                </Link>
                                            </li>
                                            <li>
                                                <Link className="pinterest" href="#" target="_blank">
                                                    <FontAwesomeIcon icon={faInstagram} />
                                                </Link>
                                            </li>
                                        </ul> */}
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-3 col-md-6">
                                <div className="footer-widget widget widget_nav_menu">
                                    <h4 className="widget-title">Quick Link</h4>
                                    <ul>
                                        <li><Link to={'/'}>Home</Link></li>
                                        <li><Link to={'/about-us'}>About Us</Link></li>
                                        <li><Link to={'/services'}>Services</Link></li>
                                        <li><Link to={'/faq'}>FAQs</Link></li>
                                        <li><Link to={'/contact'}>Contact</Link></li>
                                    </ul>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6">
                                <div className="footer-widget widget ">
                                    <h4 className="widget-title">Contact</h4>
                                    <div className="contact_info_list">
                                        <p><span>Address:</span> 1611 Remington Road Prosper, Texas 75078 United States</p>
                                        <p><span>Phone:</span> +1 (469) 983-4445</p>
                                        <p><span>E-mail:</span> sales@fusion-hub.com</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="copyright-inner">
                    <div className="copyright-text">
                        &copy; FusionHub {new Date().getFullYear()} All rights reserved.
                    </div>
                </div>
            </footer>

            <ScrollHandler />

            <div className="back-to-top" onClick={scrollToTop}>
                <span className="back-top"><FontAwesomeIcon icon={faAngleUp} /></span>
            </div>
        </>
    )
}

export default Footer

